import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/icons
import Mail from "@material-ui/icons/Mail";
import TwitterIcon from '@material-ui/icons/Twitter';
import FacebookIcon from '@material-ui/icons/Facebook';
import RedditIcon from '@material-ui/icons/Reddit';
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import { Link } from 'react-router-dom';
import Message from '@app/components/Message/Message';
import GridContainer from "@app/components/Grid/GridContainer";
import GridItem from "@app/components/Grid/GridItem";
import Button from "@app/components/CustomButtons/Button";
import CustomInput from "@app/components/CustomInput/CustomInput";
import Footer from "@app/components/Footer/Footer";
import Clearfix from "@app/components/Clearfix/Clearfix";
// styles
import footerStyle from "@app/assets/jss/material-kit-pro-react/components/footerStyle";

const SectionFooterView = props => {
    const { classes } = props;
    const yourEmail = props.intl.formatMessage({ id: "your.email" });
    const send = props.intl.formatMessage({ id: "send" });
    const newsletterEmailSuccess = props.isNewsletterEmailValid;
    const newsletterEmailError = props.validationErrors.newsletterEmail.show && !props.isNewsletterEmailValid;
    const newsletterEmailHelperText = props.validationErrors.newsletterEmail.show ? props.validationErrors.newsletterEmail.errorMessage : '';

    return (
        <div className={classes.section}>
            <Footer
                theme="white"
                content={
                    <div>
                        <ul className={classes.socialButtons}>
                            <li>
                                <Button justIcon simple 
                                    href="https://twitter.com/LocalProIE">
                                    <TwitterIcon />
                                </Button>
                            </li>
                            <li>
                                <Button justIcon simple 
                                    href="https://www.reddit.com/u/LocalProIE">
                                    <RedditIcon />
                                </Button>
                            </li>
                        </ul>
                        <div
                            className={classNames(classes.pullCenter, classes.copyRight)}
                        >
                            <FormattedMessage id="copyright" />&nbsp;&copy;&nbsp;{1900 + new Date().getYear()}{" "}
                            <Link to="/">LocalPro.ie</Link>
                            <br />
                            <FormattedMessage id="all.rights.reserved" />
                        </div>
                        <Clearfix />
                        <Button type="button" color="warning" component={Link} to="/beta">
                            <FormattedMessage id="currently.running.in.public.beta.mode" />.
                            <br />
                            <FormattedMessage id="page.timestamp" />: {new Date().toISOString()}
                        </Button>
                    </div>
                }
            >
                <div className={classes.footer}>
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={3}>
                            <h5>
                                <FormattedMessage id="about" />
                            </h5>
                            <ul className={classes.linksVertical}>
                                <li>
                                    <Link to="/about-us">
                                        <FormattedMessage id="about.us" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/blog">
                                        <FormattedMessage id="blog" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/contact-us">
                                        <FormattedMessage id="contact.us" />
                                    </Link>
                                </li>
                            </ul>
                        </GridItem>
                        {/*<GridItem xs={12} sm={12} md={3}>
                            <h5>
                                <FormattedMessage id="customers" />
                            </h5>
                            <ul className={classes.linksVertical}>
                                <li>
                                    <Link to="/how-it-works-customer">
                                        <FormattedMessage id="how.it.works" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/faq-customer">
                                        <FormattedMessage id="faq" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/pricing-customer">
                                        <FormattedMessage id="pricing" />
                                    </Link>
                                </li>
                            </ul>
                        </GridItem>*/}
                        <GridItem xs={12} sm={12} md={3}>
                            <h5>
                                <FormattedMessage id="professionals" />
                            </h5>
                            <ul className={classes.linksVertical}>
                                <li>
                                    <Link to="/how-it-works-professional">
                                        <FormattedMessage id="how.it.works" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/faq-professional">
                                        <FormattedMessage id="faq" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/pricing-professional">
                                        <FormattedMessage id="pricing" />
                                    </Link>
                                </li>
                            </ul>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={3}>
                            <h5>
                                <FormattedMessage id="legal" />
                            </h5>
                            <ul className={classes.linksVertical}>
                                <li>
                                    <Link to="/privacy-policy">
                                        <FormattedMessage id="privacy.policy" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/cookie-policy">
                                        <FormattedMessage id="cookie.policy" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/terms-of-use">
                                        <FormattedMessage id="terms.of.use" />
                                    </Link>
                                </li>
                            </ul>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={3}>
                            <h5>
                                <FormattedMessage id="keep.up.to.date" />
                            </h5>
                            <p>
                                <FormattedMessage id="email.subscribe.text" />
                            </p>
                            <p>
                                <FormattedMessage id="email.privacy.speel" />
                            </p>
                            {props.subscribed &&
                                <FormattedMessage id="email.subscribed" />
                            }
                            {props.subscriptionErrorMessage &&
                                <Message type="error" message={props.subscriptionErrorMessage} />
                            }                           
                            <form>
                                <CustomInput
                                    id="newsletterEmail"
                                    helperText={newsletterEmailHelperText}
                                    success={newsletterEmailSuccess}
                                    error={newsletterEmailError}
                                    formControlProps={{
                                        fullWidth: false
                                    }}
                                    inputProps={{
                                        name: 'newsletterEmail',
                                        value: props.newsletterEmail,
                                        placeholder: yourEmail,
                                        onChange: props.onNewsletterEmailChange
                                    }}
                                />
                                <Button
                                    type="button"
                                    disabled={props.isLoading}
                                    color="danger"
                                    className={classes.emailButton}
                                    justIcon onClick={props.subscribe}
                                    aria-label={props.intl.formatMessage({ id: "subscribe" })}>
                                    <Mail />
                                </Button>
                            </form>
                            {props.userCredential && props.gdprEmailSent &&
                                <FormattedMessage id="gdpr.report.sent" />
                            }
                            {props.gdprEmailErrorMessage &&
                                <Message type="error" message={props.gdprEmailErrorMessage} />
                            }
                            {props.userCredential &&
                                <Button type="button" disabled={props.isLoading} color="danger" onClick={props.sendGdprUserEmail}>
                                    <FormattedMessage id="get.gdpr.report" />
                                </Button>
                            }
                        </GridItem>
                    </GridContainer>
                </div>
            </Footer>
        </div>
    );
};

export default injectIntl(withStyles(footerStyle)(SectionFooterView));
